import React from 'react';
import { WordpressPost, ContentBlock } from '@benzinga/content-manager';
import { MoneyBlocks } from './MoneyBlocks';
import { NoFirstRender } from '@benzinga/hooks';

const LayoutAdmin = React.lazy(() => import('@benzinga/blocks').then(module => ({ default: module.LayoutAdmin })));

interface MoneyBlocksLayoutProps {
  post?: WordpressPost | ContentBlock;
}

export const MoneyBlocksLayout: React.FC<MoneyBlocksLayoutProps> = ({ post }) => {
  if (!post || !post.blocks) return null;
  return (
    <div className="money-blocks-layout-wrapper">
      <NoFirstRender>
        <React.Suspense>
          <LayoutAdmin post={post} />
        </React.Suspense>
      </NoFirstRender>
      <MoneyBlocks blocks={post.blocks} />
    </div>
  );
};
